var e = {
	heading: "Help & Support",
	sections: {
		home: {
			label: "Knowledge base",
			description: "Browse articles and guides."
		},
		articles: {
			label: "Articles",
			description: "Browse help topics and guides."
		},
		faq: {
			label: "FAQs",
			description: "Quick answers to common questions."
		},
		tickets: {
			label: "My requests",
			description: "View your support conversations."
		},
		contact: {
			label: "Contact support",
			description: "Start a conversation with our support team."
		},
		callback: {
			label: "Request a callback",
			description: "Leave your number — we will call you."
		}
	},
	faq: {
		title: "Frequently asked questions",
		description: "Quick answers to the most common questions."
	},
	contact: {
		title: "Contact support",
		description: "Tell us what you need and start chatting with our support team.",
		toast: {
			successTitle: "Chat started",
			successDescription: "You're connected — an agent will reply here.",
			errorTitle: "Could not submit your request"
		},
		connecting: {
			title: "Starting your conversation",
			description: "Connecting you to support — this only takes a moment.",
			timeout: "Your request is in. We'll open the conversation as soon as it's ready."
		}
	},
	callback: {
		title: "Request a callback",
		description: "Leave your number — we will call you.",
		toast: {
			successTitle: "Callback requested",
			successDescription: "Our team will call you in your preferred window.",
			errorTitle: "Could not submit your request"
		}
	},
	newTicket: {
		topicLabel: "Topic",
		subjectLabel: "Subject",
		subjectPlaceholder: "e.g. My payout has not arrived",
		messageLabel: "What is going on?",
		messagePlaceholder: "Share as much detail as you can — booking codes, dates, screenshots references…",
		submit: "Submit request",
		validation: {
			subjectRequired: "Subject is required",
			subjectTooShort: "Subject is too short",
			topicRequired: "Pick a topic",
			messageRequired: "Describe your issue",
			messageTooShort: "Please add a bit more detail"
		}
	},
	helpHome: {
		searchPlaceholder: "Search help articles (e.g. cancel a booking)",
		noArticlesYet: "Help articles are on their way — reach out to our team in the meantime.",
		noMatch: "No articles match \"{{query}}\"",
		browseByTopic: "Browse by topic"
	},
	helpCard: { description: "Find answers or get in touch with our support team." },
	faqList: { empty: "No FAQs published yet." },
	article: {
		unavailable: "This article is no longer available.",
		backToHelpCenter: "Back to help center",
		updated: "Updated {{date}}"
	},
	categoryArticles: {
		empty: "No articles in this topic yet.",
		fallbackTitle: "Help articles"
	},
	callbackForm: {
		phoneLabel: "Phone number",
		phonePlaceholder: "+20 100 123 4567",
		preferredTimeLabel: "Preferred time",
		topicLabel: "Topic (optional)",
		topicPlaceholder: "What should we call you about?",
		recentRequests: "Your recent requests",
		submit: "Request callback",
		validation: {
			phoneRequired: "Phone number is required",
			phoneInvalid: "Enter a valid phone number",
			timeSlotRequired: "Pick a time window"
		}
	},
	detailsPanel: {
		caseTitle: "Your request",
		subject: "Subject",
		status: "Status",
		category: "Topic",
		audience: "Account",
		audienceValue: {
			guest: "Traveller",
			host: "Host"
		},
		openedAt: "Opened",
		lastActivity: "Last activity",
		relatedTitle: "Might help",
		relatedArticles: "Articles",
		noRelatedContent: "Nothing to suggest yet — support will pick this up.",
		requestCall: {
			title: "Prefer a call?",
			description: "Leave a number and a good time, and support will ring you about this request.",
			cta: "Request a call",
			ctaAgain: "Request another call",
			submitted: "We've got your call request. Support will be in touch."
		},
		actions: {
			menuLabel: "Case actions",
			markInProgress: "Mark in progress",
			markResolved: "Mark resolved",
			close: "Close case",
			reopen: "Reopen case",
			assignToMe: "Assign to me",
			unassign: "Unassign",
			assignedToYou: "Assigned to you",
			unassigned: "Unassigned",
			assignee: "Assignee"
		}
	}
};
//#endregion
export { e as default };
